import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "About", href: "#about" },
  { label: "Practice", href: "#practice" },
  { label: "Careers", href: "#careers" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const onHome = pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50"
      style={{
        backgroundColor: "#F9F6F0",
        borderBottom: scrolled ? "1px solid #E2DCD0" : "1px solid transparent",
        transition: "border-color 240ms ease",
      }}
    >
      <div className="container-x flex items-center justify-between h-16 md:h-20">
        <Link to="/" data-testid="brand-monogram" className="flex items-center gap-3 group">
          <span
            className="inline-flex items-center justify-center"
            style={{
              width: 36, height: 36,
              border: "1px solid #C5A059",
              color: "#7A2021",
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 3v18" />
              <path d="M5 21h14" />
              <path d="M5 7h14" />
              <path d="M5 7l-2 6a4 4 0 0 0 8 0L9 7" />
              <path d="M19 7l-2 6a4 4 0 0 0 8 0l-2-6" />
            </svg>
          </span>
          <span className="hidden sm:flex flex-col leading-tight">
            <span
              className="font-serif-display text-base"
              style={{ color: "#0A1128", letterSpacing: "0.04em" }}
            >
              Sikdar &amp; Sikdar
            </span>
            <span
              style={{ color: "#7A2021", fontSize: "10px", letterSpacing: "0.28em", textTransform: "uppercase" }}
            >
              Advocates
            </span>
          </span>
          <span
            className="sm:hidden font-serif-display text-lg"
            style={{ color: "#0A1128", letterSpacing: "0.04em" }}
          >
            Sikdar &amp; Sikdar
          </span>
        </Link>

        {onHome && (
          <nav className="hidden md:flex items-center gap-10" aria-label="primary">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="nav-link"
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                {item.label}
              </a>
            ))}
          </nav>
        )}

        <div className="hidden md:flex items-center gap-4">
          {onHome ? (
            <a href="#contact" className="btn-primary-sm" data-testid="header-cta-consult">
              Request Consultation
            </a>
          ) : (
            <Link to="/" className="btn-secondary" data-testid="header-back-home">
              Back to Website
            </Link>
          )}
        </div>

        <button
          type="button"
          className="md:hidden inline-flex items-center justify-center"
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          style={{ color: "#0A1128", width: 44, height: 44 }}
        >
          {open ? <X strokeWidth={1.5} /> : <Menu strokeWidth={1.5} />}
        </button>
      </div>

      {open && onHome && (
        <div className="md:hidden border-t" style={{ borderColor: "#E2DCD0", backgroundColor: "#F9F6F0" }}>
          <div className="container-x py-6 flex flex-col gap-5">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="nav-link"
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
              >
                {item.label}
              </a>
            ))}
            <a href="#contact" onClick={() => setOpen(false)} className="btn-primary" data-testid="mobile-header-cta">
              Request Consultation
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
